<template>
  <div>
    <app-bar v-if="isAuthenticated" />

    <side-bar v-if="isAuthenticated" />

    <v-main class="ma-6">
      <router-view />

      <div v-if="isAuthenticated">
        <select-form-dialog :visible.sync="selectFormDialogVisible" />
        <team-form-dialog :visible.sync="teamFormDialogVisible" />
        <coach-form-dialog :visible.sync="coachFormDialogVisible" />
        <event-form-dialog :visible.sync="eventFormDialogVisible" />
        <location-form-dialog :visible.sync="locationFormDialogVisible" />
        <diagnostic-protocol-form-dialog :visible.sync="diagnosticProtocolFormDialogVisible" />
        <training-protocol-form-dialog :visible.sync="trainingProtocolFormDialogVisible" />
        <training-exercise-form-dialog :visible.sync="trainingExerciseFormDialogVisible" />
        <training-program-form-dialog :visible.sync="trainingProgramFormDialogVisible" />
        <diagnostic-results-dialog />
        <device-form-dialog :visible.sync="deviceFormDialogVisible" />
        <membership-plan-form-dialog :visible.sync="membershipPlanFormDialogVisible" />
        <parent-form-dialog :visible.sync="parentFormDialogVisible" />
        <injury-form-dialog :visible.sync="injuryFormDialogVisible" />
        <change-language-dialog :visible.sync="changeLanguageDialogVisible" />
        <support-dialog :visible.sync="supportDialogVisible" />
      </div>
    </v-main>

    <alert />
  </div>
</template>

<script>
import { CoachFormDialog, EventFormDialog, SelectFormDialog, TeamFormDialog } from '@/components/dialogs'
import Alert from '@/components/helpers/Alert'
import AppBar from '@/components/AppBar'
import LocationFormDialog from '@/components/dialogs/LocationFormDialog'
import DeviceFormDialog from '@/components/dialogs/DeviceFormDialog'
import MembershipPlanFormDialog from '@/components/dialogs/MembershipPlanFormDialog'
import ParentFormDialog from '@/components/dialogs/ParentFormDialog.vue'
import TrainingProtocolFormDialog from '@/components/dialogs/TrainingProtocolFormDialog.vue'
import TrainingExerciseFormDialog from '@/components/dialogs/TrainingExerciseFormDialog.vue'
import InjuryFormDialog from '@/components/dialogs/InjuryFormDialog.vue'
import TrainingProgramFormDialog from '@/components/dialogs/TrainingProgramFormDialog.vue'
import ChangeLanguageDialog from '@/components/dialogs/ChangeLanguageDialog.vue'
import SideBar from '@/components/SideBar.vue'
import SupportDialog from '@/components/dialogs/SupportDialog.vue'
import DiagnosticProtocolFormDialog from '@/components/dialogs/DiagnosticProtocolFormDialog.vue'
import DiagnosticResultsDialog from '@/components/dialogs/DiagnosticResultsDialog.vue'

export default {
  name: 'MainLayout',
  components: { DiagnosticResultsDialog, DiagnosticProtocolFormDialog, SupportDialog, ChangeLanguageDialog, SideBar, TrainingProgramFormDialog, InjuryFormDialog, TrainingExerciseFormDialog, TrainingProtocolFormDialog, ParentFormDialog, MembershipPlanFormDialog, DeviceFormDialog, LocationFormDialog, EventFormDialog, CoachFormDialog, SelectFormDialog, Alert, AppBar, TeamFormDialog },
  data () {
    return {
      selectFormDialogVisible: false,
      playerFormDialogVisible: false,
      teamFormDialogVisible: false,
      coachFormDialogVisible: false,
      eventFormDialogVisible: false,
      locationFormDialogVisible: false,
      diagnosticProtocolFormDialogVisible: false,
      trainingProtocolFormDialogVisible: false,
      trainingExerciseFormDialogVisible: false,
      trainingProgramFormDialogVisible: false,
      deviceFormDialogVisible: false,
      membershipPlanFormDialogVisible: false,
      parentFormDialogVisible: false,
      injuryFormDialogVisible: false,
      changeLanguageDialogVisible: false,
      supportDialogVisible: false
    }
  },
  computed: {
    appInitialized() {
      return this.$store.getters[this.$storeGetters.APP_INITIALIZED]
    },
    appHasErrors() {
      return this.$store.getters[this.$storeGetters.APP_HAS_ERRORS]
    },
    appLoading() {
      return this.$store.getters[this.$storeGetters.APP_LOADING]
    },
    isAuthenticated() {
      return this.$store.getters[this.$storeGetters.IS_AUTHENTICATED]
    },
    isAuthLoading() {
      return this.$store.getters[this.$storeGetters.AUTH_LOADING]
    }
  }
}
</script>
